'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mixpanel = require('mixpanel-browser');

var identity = function identity(value) {
    return value;
};

var renameEventData = function renameEventData(object, propFormatter, valFormatter) {
    return Object.keys(object).reduce(function (memo, key) {
        memo[propFormatter(key)] = valFormatter(object[key]);
        return memo;
    }, {});
};

module.exports = function mixpanelMiddleware(token) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    mixpanel.init(token, options.config);

    var personSelector = options.personSelector,
        uniqueIdSelector = options.uniqueIdSelector,
        _options$actionTypeFo = options.actionTypeFormatter,
        actionTypeFormatter = _options$actionTypeFo === undefined ? identity : _options$actionTypeFo,
        _options$propertyForm = options.propertyFormatter,
        propertyFormatter = _options$propertyForm === undefined ? identity : _options$propertyForm,
        _options$valueFormatt = options.valueFormatter,
        valueFormatter = _options$valueFormatt === undefined ? identity : _options$valueFormatt;


    return function (store) {
        return function (next) {
            return function (action) {
                var type = action.type,
                    _action$meta = action.meta;
                _action$meta = _action$meta === undefined ? {} : _action$meta;
                var _action$meta$mixpanel = _action$meta.mixpanel;
                _action$meta$mixpanel = _action$meta$mixpanel === undefined ? {} : _action$meta$mixpanel;
                var customType = _action$meta$mixpanel.type,
                    eventName = _action$meta$mixpanel.eventName,
                    timeEvent = _action$meta$mixpanel.timeEvent,
                    mixpanelPayload = _action$meta$mixpanel.props,
                    increment = _action$meta$mixpanel.increment;


                var result = next(action);

                if (eventName) {
                    if (personSelector && uniqueIdSelector) {
                        var person = personSelector(store.getState());
                        mixpanel.identify(uniqueIdSelector(store.getState()));
                        mixpanel.people.set(person);
                    }

                    var data = (typeof mixpanelPayload === 'undefined' ? 'undefined' : _typeof(mixpanelPayload)) === 'object' ? mixpanelPayload : {};
                    mixpanel.track(actionTypeFormatter(eventName), _extends({}, renameEventData(data, propertyFormatter, valueFormatter), {
                        action: actionTypeFormatter(customType || type)
                    }));
                }

                if (timeEvent) {
                    mixpanel.time_event(actionTypeFormatter(timeEvent));
                }

                if (Array.isArray(increment)) {
                    mixpanel.people.increment(propertyFormatter(increment[0]), increment[1]);
                } else if (increment === Object(increment)) {
                    mixpanel.people.increment(Object.keys(increment).reduce(function (inc, key) {
                        return _extends({}, inc, _defineProperty({}, propertyFormatter(key), increment[key]));
                    }, {}));
                } else if (increment) {
                    mixpanel.people.increment(propertyFormatter(increment));
                }

                return result;
            };
        };
    };
};